/**
 * **The Insights rollout switch.** The stages whose Members don't yet see Insights' reporting: no
 * web API route there (`pkgs/functions/src/web/handler.ts`), and no tab, page or setting in a web
 * app built for them (`pkgs/ui/src/insights/shown.ts`). Every stage records the facts and recovers
 * older history whatever this says. Production left the list in the rollout's second deploy, once
 * the first had shipped capture and recovery there; putting it back hides reporting again:
 * `docs/Runbooks/Roll out Insights.md`.
 */
export const reportingHiddenOn: readonly string[] = []

/** Whether the stage `stage` shows Insights' reporting; one with no name (a local build) does. */
export const insightsReportedOn = (stage: string | undefined) =>
  stage === undefined || !reportingHiddenOn.includes(stage)
